import { useState, useEffect } from "react";
import clsx from "clsx";
// MUI
import { Stack, Typography, Box, Avatar } from "@mui/material";
// Types
import { IRatingConfig } from "./interfaces";

const MAX_BAR_WIDTH = 233;
const MAX_SCORE = 5;

function calculateBarWidth(width: number) {
	return `${(width / MAX_SCORE) * MAX_BAR_WIDTH}px`;
}

interface IRatingItemProps {
	item: IRatingConfig;
}

export const RatingItem = ({ item }: Readonly<IRatingItemProps>) => {
	const [width, setWidth] = useState(0);

	const { value, icon, label } = item;

	useEffect(() => {
		setWidth(value);
	}, [value]);

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			className="w-full overflow-hidden"
			height={!value ? 0 : "auto"}
		>
			<Stack direction="row" alignItems="center" columnGap={2} width="100%">
				<Avatar alt="Social Media Icon" src={icon ?? ""} className="!w-[23px] !h-[23px]" />
				<Box
					className={clsx(
						"h-[10px] rounded-[5px] max-w-[233px] transition-[width] ease-linear duration-[0.4s] bg-gradient-to-r",
						{
							"from-gradient-green to-gradient-blue": value >= 4,
							"from-dark-yellow to-dark-red": value < 4,
						}
					)}
					width={calculateBarWidth(width)}
				/>
			</Stack>

			<Stack direction="row" alignItems="center" justifyContent="flex-end" columnGap={1} className="w-full max-w-[145px]">
				<Typography className="!text-[12px] !font-montserrat !font-semibold text-default">{label}</Typography>
				<Typography
					className={clsx("!text-[27px] !font-montserrat !font-bold", {
						"text-gradient-gray-blue": value >= 4,
						"text-gradient-orange": value < 4,
					})}
				>
					{value?.toFixed(1) ?? 0}
				</Typography>
			</Stack>
		</Stack>
	);
};
